import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';
import { genericCopyItem } from '../stores/copy-paste/copy-paste-actions';
import { merge, path, equals, omit } from 'ramda';

const CopyPasteContainer = props => {
  const {
    copyPasteReducer,
    type,
    id, // this is a unique STRING. NOT uuid
    copiedContent,
    pasteFunc,
    outerDivStyle,
    copyButtonOuterStyle,
    copyButtonStyle,
    pasteButtonOuterStyle,
    pasteButtonStyle,
    copyLabelStyle,
    pasteLabelStyle,
    dispatchGenericCopyItem,
  } = props;

  const isItemCopied = equals(path([type, 'id'], copyPasteReducer), id);

  return (
    <div style={outerDivStyle}>
      <div style={copyButtonOuterStyle}>
        <RaisedButton
          label={isItemCopied ? 'Copied' : 'Copy'}
          labelStyle={copyLabelStyle}
          backgroundColor={isItemCopied ? '#d8d8d8' : ''}
          style={copyButtonStyle}
          onTouchTap={() => dispatchGenericCopyItem({ [type]: merge(copiedContent, { id }) })}
        />
      </div>
      <div style={pasteButtonOuterStyle}>
        <RaisedButton
          label="Paste"
          secondary
          labelStyle={pasteLabelStyle}
          style={pasteButtonStyle}
          onTouchTap={() => pasteFunc(omit(['id'], copyPasteReducer[type]))}
          disabled={!Boolean(copyPasteReducer[type]) || isItemCopied}
        />
      </div>
    </div>
  );
};

CopyPasteContainer.propTypes = {
  outerDivStyle: PropTypes.object,
  copyButtonOuterStyle: PropTypes.object,
  pasteButtonOuterStyle: PropTypes.object,
  type: PropTypes.string,
  pasteFunc: PropTypes.func,
  copyPasteReducer: PropTypes.object,
  dispatch: PropTypes.func,
  copiedContent: PropTypes.any,
  id: PropTypes.string,
  copyButtonStyle: PropTypes.object,
  pasteButtonStyle: PropTypes.object,
  copyLabelStyle: PropTypes.object,
  pasteLabelStyle: PropTypes.object,
  dispatchGenericCopyItem: PropTypes.func,
};

const mapStateToProps = ({ copyPaste }) => ({
  copyPasteReducer: copyPaste.toJS(),
});

const mapDispatchToFunc = dispatch => ({
  dispatchGenericCopyItem: (...args) => dispatch(genericCopyItem(...args)),
});

export default connect(mapStateToProps, mapDispatchToFunc)(CopyPasteContainer);



// WEBPACK FOOTER //
// ./src/app/components/copy-paste.jsx